import { createColumnHelper, renderUnknownValue, Table } from '@dittolive/anvil'
import React from 'react'
import { useMemo } from 'react'
import AutoSizer from 'react-virtualized-auto-sizer'

/**
 * A single row in the test query result
 */
export type TestDataBridgeQueryResultRow = Record<string, unknown>

/**
 * The result of a test query execution
 */
export type TestDataBridgeQueryResult = TestDataBridgeQueryResultRow[]

type Props = {
  result: TestDataBridgeQueryResult
}

export default function TestResultTable({ result }: Props) {
  const formatedData = useMemo<Record<string, unknown>[]>(() => {
    return result.map(({ _id, ...doc }) => ({
      id: _id,
      ...doc,
    }))
  }, [result])

  const dataKeys = useMemo(() => {
    return Array.from(
      new Set(
        formatedData
          .map((doc) => Object.keys(doc))
          .reduce((acc, keys) => [...acc, ...keys], []),
      ),
    )
  }, [formatedData])

  const columns = useMemo(
    () =>
      dataKeys.map((key) =>
        columnHelper.accessor(key, {
          header: () => <span className="font-plex-mono px-2.5">{key}</span>,
          cell: ({ row: { original } }) => renderUnknownValue(original[key]),
          enableSorting: false,
        }),
      ),
    [dataKeys],
  )

  return (
    <>
      <div className="flex h-10 w-full shrink-0 items-center justify-between px-4">
        <span>Result</span>

        <span>100 limit</span>
      </div>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            tableClassName="table-auto"
            data={formatedData}
            columns={columns}
            height={height}
            width={width}
            divide="cells"
            tableCellClassName="font-plex-mono whitespace-nowrap overflow-hidden text-ellipsis"
          />
        )}
      </AutoSizer>
    </>
  )
}

const columnHelper = createColumnHelper<Record<string, unknown>>()
